VLW.vin       = {};
VLW.vin.Fiche = class extends VLW.classBase {
	constructor(ctrl) {
		super();
		this.ctrl              = ctrl;
		this.cntrImage         = document.querySelectorAll("[data-vlw-autoVars='imgContainer']");
		this.pdf               = this.ctrl.qs("[data-vlw-autoVars='pdf']");
		this.millesime         = this.ctrl.qs("[data-vlw-autoVars='millesime']");
		this.selectMillesime   = this.ctrl.qs("[data-vlw-autoVars='millesimeSelect']");
		this.json              = (EXTRADATA && EXTRADATA["ficheVin"]) ? EXTRADATA["ficheVin"] : {};
		this.millesimeSelected = this.json.millesimeSelected;
		this.selectMillesime && [...this.selectMillesime.querySelectorAll("li div")].forEach((elt)=>{
			elt.addEventListener("click", this.changeMillesime);
		});
	}
	changeMillesimeLabel(millesime){
		this.millesime && TweenMax.to(this.millesime    , .75, {scale:.9,autoAlpha:0,onComplete:this.changeContenu_2,onCompleteParams:[this.millesime,millesime]});
	}

	changeMillesime(e) {
		if (!this.json || !this.json.millesimes) return;
		history.replaceState(null, null, this.ctrl.mainElementJS.getAttribute('data-url') + "/" + e.currentTarget.getAttribute("value"));
		this.millesimeSelected = this.json.millesimes[e.currentTarget.getAttribute("value")];
		try {
			this.pdf && this.pdf.setAttribute("href", (this.millesimeSelected.pdf || ""));
			this.changeContenu			(this.millesimeSelected.content);
			this.changeBouteille		(this.millesimeSelected);
			this.changeMillesimeLabel	(this.millesimeSelected.libelle);
		} catch (e) {
			console.log(e);
		}
	}
	changeBouteille(millesime) {
		if(!this.cntrImage || this.cntrImage[0].querySelector("img").getAttribute("src")=== millesime.bouteille.site.fichier)return;
		let loaderImg    = new Image();
		loaderImg.src    = millesime.bouteille.site.fichier;
		loaderImg.onload = this.onLoadImg;
	}
	onLoadImg(e) {
		TweenMax.to(this.cntrImage, .75, {
			opacity: 0, zIndex: "", onCompleteParams: [e.currentTarget], onComplete: (newImg)=> {
				this.cntrImage.forEach((unContainer)=>{
					unContainer.innerHTML = "";
					unContainer.appendChild(newImg.cloneNode(true));
					TweenMax.to(unContainer, .5, {opacity: 1, delay: .25});
				});
			}
		});
	}
	changeContenu(content) {
		TweenMax.to(this.ctrl.mainElementJS.querySelector("[data-millesime-content]"), .25, {y: 15, autoAlpha: 0, onComplete: this.changeContenu_2, onCompleteParams: [this.ctrl.mainElementJS.querySelector("[data-millesime-content]"), content.center]});
	}
	changeContenu_2(elt, content) {
		elt.innerHTML = content;
		TweenMax.fromTo(elt, .5, {y: -15}, {y: 0, autoAlpha: 1, force3D: true, clearProps: "transform"});
		TweenMax.staggerFromTo(elt.querySelectorAll("._champ p,._champ h2")	, 1.25, {transformOrigin: "100% 0", y: -50, opacity: 0}		, {y: 0, opacity: 1, ease: Power2.easeOut}, .15, 0);
		// TweenMax.staggerFromTo(elt.querySelectorAll("._champ h2")	, 1.25, {transformOrigin: "100% 0",x : "-120%", opacity: 0}	, {y: 0,x:"0%", opacity: 1, ease: Power2.easeOut}, .15, 0);
	}

	instanceClean() {
		//$(this.selectMillesime).off('change', this.changeMillesime);
		super.instanceClean();
	}

};
